var studcalculator = {
    studelements: {
        main: undefined,
        type: undefined,
        productqty: undefined,
        productform: undefined,
        calcaddtocart: undefined,
        productwidth: undefined,
        productlength: undefined,
        productheight: undefined,
        inputwidth: undefined,
        inputlength: undefined,
        resultmain: undefined,
        resultmainempty: undefined,
        resultmeters: undefined,
        resultwidth: undefined,
        resultlength: undefined,
        resultheight: undefined,
        resultamount: undefined,
        resultcontent: undefined,
        resultqty: undefined,
    },
    debugchecks: {
        active: false,
        main: undefined,
        type: undefined,
        productqty: undefined,
        productform: undefined,
        calcaddtocart: undefined,
        width: undefined,
        length: undefined,
        resultmain: undefined,
        resultmainempty: undefined,
        resultmeters: undefined,
        resultwidth: undefined,
        resultlength: undefined,
        resultheight: undefined,
        resultamount: undefined,
        resultcontent: undefined,
        resultqty: undefined,
    },
    studtype: undefined,
    studwidth: undefined,
    init: function () {
        this.setElements();
        if (this.valid()) {
            this.debug();
            this.clickEvents();
            this.updateForm();
        } else {
            this.debugchecks.active = "ERROR";
            this.debug();
        }
    },
    setElements: function () {
        this.studelements.main = document.getElementById('studcalculator');
        this.studelements.type = document.getElementById('calculation-type');
        this.studelements.productqty = document.querySelectorAll('input[id^="quantity_"]')[0];
        this.studelements.productform = document.getElementById('product-form');
        this.studelements.calcaddtocart = document.getElementById('calculation-add-to-basket');
        this.studelements.productwidth = document.getElementById('pa_width');
        this.studelements.productlength = document.getElementById('pa_length');
        this.studelements.productheight = document.getElementById('pa_height');
        this.studelements.inputwidth = document.getElementById('calculation-width');
        this.studelements.inputlength = document.getElementById('calculation-length');
        this.studelements.resultmain = document.getElementById('calculation-result');
        this.studelements.resultmainempty = document.getElementById('calculation-result-empty');
        this.studelements.resultmeters = document.getElementById('calculation-result-meters');
        this.studelements.resultwidth = document.getElementById('calculation-result-width');
        this.studelements.resultlength = document.getElementById('calculation-result-length');
        this.studelements.resultheight = document.getElementById('calculation-result-height');
        this.studelements.resultamount = document.getElementById('calculation-result-amount');
        this.studelements.resultcontent = document.getElementById('calculation-content');
        this.studelements.resultqty = document.getElementById('calculation-qty');
    },
    valid: function () {
        var result = true;
        Object.keys(this.studelements).forEach(key => {
            if (this.studelements[key] == undefined) {
                this.debugchecks[key] = "Invalid";
                //result = false;
            } else {
                this.debugchecks[key] = "Valid";
            }
        });
        this.debugchecks.active = true;
        return result;
    },
    clickEvents: function () {
        const instance = this;
        if (this.studelements.type != undefined) {
            this.studelements.type.addEventListener('input', function () {
                instance.updateForm();
            });
        }
        if (this.studelements.inputwidth != undefined) {
            this.studelements.inputwidth.addEventListener('input', function () {
                instance.updateForm();
            });
        }
        if (this.studelements.inputlength != undefined) {
            this.studelements.inputlength.addEventListener('input', function () {
                instance.updateForm();
            });
        }
        if (this.studelements.productwidth != undefined) {
            this.studelements.productwidth.addEventListener('input', function () {
                instance.updateForm();
            });
        }
        if (this.studelements.productlength != undefined) {
            this.studelements.productlength.addEventListener('input', function () {
                instance.updateForm();
            });
        }
        if (this.studelements.productheight != undefined) {
            this.studelements.productheight.addEventListener('input', function () {
                instance.updateForm();
            });
        }
        if (this.studelements.calcaddtocart != undefined) {
            this.studelements.calcaddtocart.addEventListener('click', function () {
                if (instance.studelements.calcaddtocart.classList.contains('disabled')) {

                } else {
                    instance.addToBasket();
                }

            });
            this.studelements.resultqty.addEventListener('change', function () {
                instance.studelements.productqty.value = instance.studelements.resultqty.value;
            });
            this.studelements.productqty.addEventListener('change', function () {
                instance.studelements.resultqty.value = instance.studelements.productqty.value;
            });
        }
    },
    updateForm: function () {
        this.calculate();
        if(this.studelements.type != undefined){
            if (this.studelements.type.checked) {
                //Square Meters
                this.studelements.inputwidth.style.display = "block";

            } else {
                //Linear
                this.studelements.inputwidth.style.display = "none";
            }
            if(this.studelements.productwidth != undefined){
                if (
                    this.studelements.productwidth.value != 0 &&
                    this.studelements.productheight.value != 0 &&
                    this.studelements.productlength.value != 0
                ) {
                    this.studelements.resultmain.style.display = "flex";
                    this.studelements.resultmainempty.style.display = "none";

                } else {
                    this.studelements.resultmain.style.display = "none";
                    this.studelements.resultmainempty.style.display = "block";

                }
            }

        }

        if (this.studelements.productwidth != undefined) {
            this.studelements.resultheight.innerHTML = this.studelements.productheight.value;
        }
        if (this.studelements.productwidth != undefined) {
            this.studelements.resultwidth.innerHTML = this.studelements.productwidth.value;
        }
        if (this.studelements.productlength != undefined && this.studelements.resultlength != undefined) {
            this.studelements.resultlength.innerHTML = this.studelements.productlength.value;
        }

    },
    calculate: function () {
        result = 0;
        if(this.studelements.type != undefined) {
            if (this.studelements.type.checked) {
                //Square Meters
                var sqm = this.studelements.inputlength.value * this.studelements.inputwidth.value;
                var persqm = 0.4 * 0.4;

                result = (sqm / persqm) * 36;
                result = Math.ceil(result);
                this.studelements.resultmeters.innerHTML = sqm + 'm&sup2;';
                this.studelements.resultamount.innerHTML = result;
            } else {
                //Linear
                var result = (this.studelements.inputlength.value / 0.4) * 6;
                result = Math.ceil(result);
                this.studelements.resultmeters.innerHTML = this.studelements.inputlength.value + 'm';
                this.studelements.resultamount.innerHTML = result;
            }
            this.studelements.resultqty.value = result;
            this.studelements.productqty.value = result;
        }
    },
    addToBasket: function () {
        var addToCartButtons = document.querySelectorAll('button[name="add-to-cart"]');

        if (addToCartButtons.length > 0) {
            addToCartButtons.forEach(function (button) {

                button.click();
            });
        }
        var addToCartButtons = document.querySelectorAll('button.single_add_to_cart_button');

        if (addToCartButtons.length > 0) {
            addToCartButtons.forEach(function (button) {

                button.click();
            });
        }
        //single_add_to_cart_button
    },
    debug: function () {
        // console.table({
        //     'Active': this.debugchecks.active,
        //     'main': this.debugchecks.main,
        //     'type': this.debugchecks.type,
        //     'productform': this.debugchecks.productform,
        //     'productqty': this.debugchecks.productqty,
        //     'productwidth': this.debugchecks.productwidth,
        //     'productlength': this.debugchecks.productlength,
        //     'productheight': this.debugchecks.productheight,
        //     'resultmain': this.debugchecks.resultmain,
        //     'resultmeters': this.debugchecks.resultmeters,
        //     'inputwidth': this.debugchecks.inputwidth,
        //     'inputlength': this.debugchecks.inputlength,
        //     'resultwidth': this.debugchecks.resultwidth,
        //     'resultlength': this.debugchecks.resultlength,
        //     'resultamount': this.debugchecks.resultamount,
        //     'resultheight': this.debugchecks.resultheight,
        //     'calcaddtocart': this.debugchecks.calcaddtocart,
        // });
    }

}

export default studcalculator;

